import React, { useEffect } from "react";
import { Box, Tabs, Tab, TextField, InputAdornment, IconButton } from "@material-ui/core";
import { Clear as ClearIcon } from "components/MaterialSymbol/MaterialIcons";

export default function FiltersHeader({
    selectedPlanId,
    setSelectedPlanId,
    filters,
    onSearchChange,
    searchValue,
    setSearchValue,
}) {
    const handleTabChange = (_, newValue) => {
        setSelectedPlanId(newValue); // también reinicia el buscador desde el padre
    };

    useEffect(() => {
        const delayDebounce = setTimeout(() => {
            onSearchChange(searchValue.trim());
        }, 500);

        return () => clearTimeout(delayDebounce);
    }, [searchValue]);

    return (
        <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={2}
            flexWrap="nowrap"
        >
            <Box
                style={{
                    overflowX: "auto",
                    whiteSpace: "nowrap",
                    flex: 1,
                    paddingRight: 16,
                    display: "flex",
                    alignItems: "center",
                }}
            >
                <Tabs
                    value={selectedPlanId}
                    onChange={handleTabChange}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="scrollable"
                    scrollButtons="auto"
                    aria-label="scrollable tabs"
                    TabIndicatorProps={{ style: { height: 2 } }}
                    style={{ minHeight: 36 }}
                >
                    {filters.map((f) => (
                        <Tab
                            key={f.value}
                            value={f.value}
                            label={f.label}
                            style={{
                                minHeight: 36,
                                minWidth: "auto",
                                padding: "4px 8px",
                                fontSize: 13,
                                fontWeight: 500,
                            }}
                        />
                    ))}
                </Tabs>
            </Box>

            <TextField
                variant="outlined"
                size="small"
                placeholder="Search"
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
                style={{ minWidth: 240 }}
                InputProps={{
                    endAdornment: searchValue ? (
                        <InputAdornment position="end">
                            <IconButton size="small" onClick={() => setSearchValue("")}>
                                <ClearIcon fontSize="small" />
                            </IconButton>
                        </InputAdornment>
                    ) : null,
                }}
            />
        </Box>
    );
}
